import Vue from 'vue'
import App from './App.vue'
import Router from 'vue-router'
import store from './store'
import Vuex from 'vuex'
import VueI18n from 'vue-i18n'

Vue.config.productionTip = false;
Vue.use(Router);

/**
 * Vuex Storage
 */
Vue.use(Vuex);


const messages = {
    en: {
        navigation: {
            rooms: 'Rooms',
            food: 'Restaurant',
            confService: 'Conference service',
            service: 'SERVICES',
            news: 'News',
            career: 'Career',
            contact: 'Contacts',
            booking: 'Booking',
            faq: 'FAQ',
            about: 'About us'
        },
        booking: {
            title: 'BOOK NOW',
            label1: 'Check in',
            label2: 'Departure',
            label3: 'Guests',
            guest: 'person',
            guests: 'persons',
            discount: 'If book on site'
        },
        videoSection: {
            description: ' is the hotel located in Arcadia, the vivid tourist\n' +
            '                              area of the city. Gagarinn Hotel is the best place for business and leisure\n' +
            '                              that is located not far from the beaches, nightclubs,\n' +
            '                              up-to-date restaurants and other city attractions.',
            descriptionMob: 'Gagarinn Hotel provides such services as taxi-transfer, car rent, private\n' +
            'parking, Wi-Fi, restaurant and shopping centre. The hotel has dry\n' +
            'cleaning, laundry and luggage storage as well as lobby bar with a wide\n' +
            'cocktail menu.\n',
            freeTransfer: 'When booking, make sure to use the promocode BIRTHDAY ',
            freeTransfer2: 'to receive a discount',
            freeTransferMob: [
                {text: 'When booking, make sure'},
                {text: 'to use the promocode BIRTHDAY'},
                {text: 'to receive a discount.'},
            ]
            /*freeTransfer: 'Hello! Gagarinn Hotel is temporarily closed during the quarantine period, please write us at sales@gagarinn.com',
            freeTransferMob: [
                {text: 'Hello! Gagarinn Hotel is temporarily closed during the quarantine period,'},
                {text: 'please write us at sales@gagarinn.com'},
                {text: 'and our manager will contact you'},
            ]*/
        },
        longStaySection: {
            title: 'Long Stay',
            text1: 'Programme for a long stay at Gagarinn Hotel - minus 15% of the room rate!*',
            text2: 'And to make your stay even more enjoyable, we give our guests with children a coupon for one free visit to our Gagarinn Kids Park, so that your children can enjoy exciting entertainment!',
            moreBtn: 'Learn more'
        },
        confSection: {
            title: 'Conference service',
            text1: ' The complex of 9 modern conference halls is located on the third and fourth floors of\n' +
            '                         Gagarinn Hotel. You can rent a room for any corporate or private event:\n' +
            '                         conferences, presentations, seminars, workshops, business meetings,\n' +
            '                         team-building etc.',
            text2: ' High-speed Wi-Fi, up-to-date multimedia technologies and air conditioning\n' +
            '                         system with temperature control ensure effective and productive work.',
            moreBtn: 'Learn more',
            moreBtnLink: 'https://conference.gagarinn.com/en'
        },
        kidsSection: {
            title: 'Free for kids up to 16 years old',
            text1: 'We are glad to present a unique offer among hotels in Odesa.',
            text2: 'Gagarinn Hotel wants to make your family vacation even more affordable.\n' +
                'That is why all children up to 16 years old can enjoy vacation in rooms of category "Studio"\n' +
                'or "Suite" in Gagarinn Hotel absolutely for free!',
            moreBtn: 'Learn more',
        },
        fitnessSection: {
            title: 'Fitness',
            text: 'Fitness is still under construction, but see you soon',
            casinoTitle: 'Casino',
            casinoText: 'On the 8th floor of the Gagarinn Hotel at the First Casino you will find:',
            casinoListItem1: '9 roulette tables;',
            casinoListItem2: '40 card and poker tables;',
            casinoListItem3: '300 slot machines;',
            casinoListItem4: 'comfortable private halls;',
            casinoListItem5: '3 bars and a restaurant with European cuisine.',
            casinoText2: 'The First Casino is open 24/7.',
        },
        foodSection: {
            title: 'Gagarinn Food Hub Restaurant',
            text1 : 'You can find Gagarinn Food Hub restaurant on the second floor of the\n' +
            '                         Gagarinn Hotel. Gagarinn Food Hub can host nearly 300 guests. This is a\n' +
            '                         great place for business meetings, corporate and special events or\n' +
            '                         ordinary lunches. We offer dishes of European, Asia, Ukrainian, local\n' +
            '                         Odesa cuisine as well as wide cocktail menu. Our hospitality and\n' +
            '                         high-quality service is the guarantee that your stay at the Gagarinn Hotel\n' +
            '                         will be as great as possible.',
            text2: 'Restaurant treats guests with breakfast every day from 8:00 a.m. to 11 p.m.',
            text3: '',
            moreBtn: 'Learn More',
            menu: 'Menu',
            // link: '/pdf/menu-eng.pdf',
            // link: 'https://gagarinn-food-hub.choiceqr.com/',
            link: 'https://smartspot.servio.support/ServioQR/restaurant?rID=9483910e-66d4-465e-821c-acd663d3cc2a&tableID=2837',
        },
        faqSection: {
            title: 'Frequently asked questions',
            question1: 'Where can I do ironing?',
            answer1: 'There is an ironing room on the 6th floor. When exiting the elevator,\n' +
                'turn right and next to the service elevator there is an ironing room available 24/7.',
            question2: 'Is there a charger and can you provide it?',
            answer2: 'The charger is provided at the reception.',
            question3: 'Is it possible to move out the room and leave things somewhere? (Is there a left-luggage room?)',
            answer3: 'There is a left-luggage office on the 1st floor. In order to\n' +
                'leave things, guests need to contact the reception. Storage is free until the end of the check-out day.',
            question4: 'Do you have smoking areas?',
            answer4: 'Smoking areas are located on floors 5-10-15 on the balcony at the end of the corridor. Smoking in rooms is prohibited.',
            question5: 'Is there a beach towel, can you provide?',
            answer5: 'We provide a beach towel upon request of the guest. To get it, you need to contact the reception.',
            question6: 'Is there a first aid kit?',
            answer6: 'Yes there is. We can provide everything except medicines.',
            question7: 'Where to get an additional household components in the rooms:\n' +
                'electric kettle in the room, etc.',
            answer7: 'For additional household components, please contact the reception.',
            question8: 'How to get to the restaurant?',
            answer8: 'The restaurant is located on the 2nd floor. Phone number for booking tables',
            question9: 'Early check-in conditions?',
            answer9: 'From October to May: before 06:00 100% of the daily rate, after 06:00 50% of the daily rate.\n' +
                'From May to September before the standard check-in time (14:00) 100% of the daily rate.',
            question10: 'Where to spend time with children?',
            answer10_1: 'On the territory of the hotel complex there are children\'s entertainment centers: the city of professions "KIDS CITY" and the trampoline park "KIDS PLANET".',
            question11: 'Is it possible to live with animals?',
            answer11_1: 'The hotel allows pets: dogs and cats. Accommodation of guests with other animals is agreed with the hotel management additionally.',
            answer11_2: 'The cost of accommodation per animal:',
            answer11_3: '*up to 50 cm with a withers - 500.00 UAH/night and pet deposit - 2500 UAH (for the whole period of stay).',
            answer11_4: '*over 50 cm with a withers - 800.00 UAH/day and a pet deposit - 5000 UAH (for the whole period of stay).',
            answer11_5: 'This amount is intended for special cleaning of the room after the departure of the guest with pets.',
            answer11_6: 'A guest with a pet is provided free of charge:',
            answer11_7: 'a bowl;',
            answer11_8: 'disposable diaper;',
            answer11_9: 'pet bed.'
        },
        contactSection: {
            title: 'Contacts',
            blocks: {
                addres:{
                    title: 'Our contacts',
                    data: [
                        {  type: 'text', isActive: false, text: '5B, Arkadiiske Plato, Odesa City, Ukraine 65009' }
                    ]
                },
                conference: {
                    title: 'CONFERENCE SERVICE',
                    data: [
                        { type: 'phone', isActive: true, text: '+38 (073) 774 44 73 (24/7)', callTrackingId: '3', val: '0737744473'},
                        { type: 'phone', isActive: true, text: '+38 (093) 536 03 16', callTrackingId: '8', val: '0935360316' },
                        { type: 'email', isActive: true, text: 'conference@gagarinn.com' },
                        { type: 'email', isActive: true, text: 'sales@gagarinn.com' }
                    ]
                },
                booking: {
                    title: 'BOOKING',
                    data: [
                        { type: 'phone', isActive: true, text: '+38 (073) 774 44 73', callTrackingId: '3', val: '0737744473' },
                        { type: 'phone', isActive: true, text: '+38 (048) 774 44 73', callTrackingId: '3', val: '0487744473' },
                        { type: 'phone', isActive: true, text: '+38 (063) 735 44 18', callTrackingId: '3', val: '0637354418' },
                        { type: 'email', isActive: true, text: 'sales@gagarinn.com' }
                    ]
                },
                food_hub: {
                    title: 'Food Hub',
                    data: [
                        { type: 'phone', isActive: true, text: '+38 (063) 735 20 60', callTrackingId: '6', val: '0637352060' },
                        { type: 'text', isActive: false, text: '5B, Arkadiiske Plato' }
                    ]
                },
                child:{
                    title: 'Gagarinn Kids',
                    data: [
                        { type: 'phone', isActive: true, text: '+38 (093) 170 70 10', callTrackingId: '7', val: '0931707010' },
                        { type: 'text', isActive: false, text: '5B, Arkadiiske Plato' }
                    ]
                },
                mall:{
                    title: 'Gagarinn Plaza Mall',
                    data: [
                        { type: 'phone', isActive: true, text: '+38 (093) 330 09 89', callTrackingId: '',val: '0933300989' },
                        { type: 'phone', isActive: true, text: '+38 (093) 330 13 75', callTrackingId: '',val: '0933301375' },
                    ]
                },
                // kidswill:{
                //     title: 'Kidswill',
                //     data: [
                //         { type: 'phone', isActive: true, text: '+38 (093) 088 66 64', callTrackingId: '',val: '0930886664' },
                //         { type: 'phone', isActive: true, text: '+38 (093) 088 66 69', callTrackingId: '',val: '0930886669' },
                //     ]
                // },
                policy: {
                    data: [
                        { type: 'link', isActive: true, text: 'Privacy Policy', callTrackingId: '', link: '/pdf/privacy.pdf' },
                        { type: 'link', isActive: true, text: 'Public Offer', callTrackingId: '', link: '/pdf/agreement.pdf' },
                        { type: 'link', isActive: true, text: 'About Us', callTrackingId: '', link: '/pdf/presentation.pdf' },
                    ]
                }
            }
        },
        services: {
            services: 'Services',
            arrival: 'Arrival from 14:00',
            departure: 'Departure at 11:00',
            concierge: 'Concierge service',
            laundry: 'Laundry',
            restaurant: 'Food Hub Restaurant',
            restaurant_full: 'Restaurant of European, Japanese and Ukrainian cuisine Food Hub',
            lobby: 'Lobby bar 24/7',
            roomService: 'Round-the-clock Room Service',
            conferenceService: 'Conference service',
            mall: 'Shopping mall',
            pet: 'Pet Friendly'
        },
        bathroom: {
            bathroom: 'Bathroom',
            shower: 'shower',
            bath: 'bath',
            hairdryer: 'hairdryer',
            towels: 'towels',
            bath_robes: 'bath robes',
            slippers: 'slippers',
            toiletries: 'free toiletries',
        },
        accommodation: {
            accommodation: 'Room accommodation',
            double_bed: 'double bed',
            two_beds: 'two single beds',
            conditioner: 'air conditioner',
            tv: 'TV set',
            telephone: 'telephone',
            safe: 'safe',
            minibar: 'mini-bar',
            luggage: 'luggage socle',
            hangers: 'hangers',
            secretaire: 'secretaire',
            chair: 'chair',
            mirror: 'mirror',
            mirror_big: 'big mirror',
            wardrobe: 'wardrobe',
            wifi: 'WI-FI',
            kingsize: 'King Size bed',
            sofa: 'fold-out sofa',
            table: 'low table',
            anteroom: 'anteroom',

        },
        roomStandard: {
            title: 'Standard Room',
            textTop: ' One-room accommodation with all the modern amenities.\n' +
            '                              There are available several types of Standard rooms: with a double bed or two single beds.\n' +
            '                              When booking a Standard room  you also gain access to the view over the Gagarinn Plaza shopping mall.\n' +
            '                              Standard rooms are located on 4-5th floors of the hotel.',
            priceTitle: 'Price',
            priceDescription: 'uah',
            areaTitle: 'Area',
            areaDescription: 'm2',
            guests: 'Guests',
            guestDescription: 'per',
            subTitle1: '',
            subDescription1: '',
            subTitle2: '',
            subDescription2: '',
            subTitle3: '',
            subDescription3: '',
        },
        roomDeluxe: {
            title: 'Superior Room/deluxe',
            textTop: ' Superior rooms are designed in European style and arranged with cozy furniture.\n' +
            '                              They are available in several variations: with a double bed or two single beds. These rooms are located on 6-18th floors of the hotel.',
            priceTitle: 'Price',
            priceDescription: 'uah',
            areaTitle: 'Area',
            areaDescription: 'm2',
            guests: 'Guests',
            guestDescription: 'per',
            subTitle1: '',
            subDescription1: '',
            subTitle2: '',
            subDescription2: '',
            subTitle3: '',
            subDescription3: '',
        },
        roomLux: {
            title: 'Suite Room',
            textTop: ' Two-room Suite designed in European style with the large double bed and\n' +
            '                              modern furniture. When booking a Suite Room you also gain access to the superb\n' +
            '                              panoramic views over the city. Suite Rooms are located on\n' +
            '                              4-19 floors. The number of guests: 1-4.',
            priceTitle: 'Price',
            priceDescription: 'uah',
            areaTitle: 'Area',
            areaDescription: 'm2',
            guests: 'Guests',
            guestDescription: 'per',
            subTitle1: '',
            subDescription1: '',
            subTitle2: '',
            subDescription2: '',
            subTitle3: '',
            subDescription3: '',
        },
        roomStudio: {
            title: 'Studio',
            textTop: ' Studio consists of two zones: a bedroom and living room. Two variants of\n' +
            '                              views from the window: on the sea or the city. Located on the 8 and 19\n' +
            '                              floors. The number of guests: 1-4.',
            priceTitle: 'Price',
            priceDescription: 'uah',
            areaTitle: 'Area',
            areaDescription: 'm2',
            guests: 'Guests',
            guestDescription: 'per',
            subTitle1: '',
            subDescription1: '',
            subTitle2: '',
            subDescription2: '',
            subTitle3: '',
            subDescription3: '',
        },
        roomFamily: {
            title: 'Family Suite',
            textTop: ' Family Suite has two bedrooms and a living room executed in European\n' +
              '                              style. The windows open up a panoramic view of the sea and\n' +
              '                              the city. Rooms are located on the 13th floor and are equipped with\n' +
              '                              modern technics, furniture, a queen size bed in each\n' +
              '                              bedroom, as well as a large expandable sofa in the living room. Family\n' +
              '                              Suite has two separate bathrooms - one with a shower, and another one\n' +
              '                              with a bath.',
            priceTitle: 'Price',
            priceDescription: 'uah',
            areaTitle: 'Area',
            areaDescription: 'm2',
            guests: 'Guests',
            guestDescription: 'per',
            subTitle1: '',
            subDescription1: '',
            subTitle2: '',
            subDescription2: '',
            subTitle3: '',
            subDescription3: '',
        },
        longStayModal: {
            p1: 'The Gagarinn Hotel offers convenient facilities for long stays to make you feel at home during your stay.',
            p2: 'One of our special offers for you is a 15%* discount on accommodation if you book a room for 5 nights or more. Please note that the minimum stay for this rate is 5 days.',
            p3: 'Your room rate also includes Wi-Fi, so you can stay connected and enjoy high-speed internet at any time.',
            // p4: 'We offer accommodation for children under 6 years old free of charge in the same room as their parents, without providing an extra bed. And for the little ones - children under 3 years old, we are pleased to offer a baby cot in all room categories at no extra charge.',
            // p5: 'We offer free accommodation for the youngest - children up to 16 years old, when booking family rooms of the Studio or Luxury category, and we are happy to offer a baby cot in all room categories at no extra charge.',
            p6: 'And to make your stay even more enjoyable, we give our guests with children a coupon for one free visit to our Gagarinn Kids Park, so that your children can enjoy exciting entertainment!',
            p7: 'For your convenience, two extra beds in the form of a sofa bed are available in our Suite and Studio rooms. An extra bed costs UAH 500.00 per night per person for children aged 7 to 11, and UAH 750 for children aged 12 and above or adults, breakfast not included.',
            p8: 'We would also like to delight you with special price for buffet breakfasts:',
            p9: 'Children under 3 years old: free breakfasts',
            p10: 'Children from 3 to 12 years old: 300 UAH',
            p11: 'From 12 years old and for adults: 400 UAH',
            p12: 'We strive to make your extended stay at Gagarinn Hotel as comfortable and enjoyable as possible. By providing special conditions, we hope to make you feel at home!',
            p13: '*Tourist tax in the amount of UAH 40,00 per person per day is not included in the room rate and must be paid additionally.'
        },
        kidsModal: {
            p1: 'We\'re pleased to announce a new promotion for families with children. Now all children up to 16 years old can enjoy their vacations in rooms of category "Studio" or "Suite" in Gagarinn Hotel absolutely for free!*',
            p2: 'The main goal of Gagarinn Hotel is to provide comfort and top class service for everyone, especially for the youngest family members. Free accommodation for children is a great opportunity to spend more on entertainment and experiences during your family vacation!**',
            p3: 'We would also like to delight you with special price for buffet breakfasts:',
            p4: 'Children under 3 years old: free breakfasts',
            p5: 'Children from 3 to 12 years old: 300 UAH',
            p6: 'From 12 years old and for adults: 400 UAH',
            p7: 'Do not miss the opportunity to visit Gagarinn Hotel and get an unforgettable experience with your family in Odesa! Book your room today and create moments that you will remember forever. Now it\'s time to start planning your family vacation!',
            p8: '*Regardless of the number of children in the family.',
            p9: '**The offer is combined with the "Long Stay" programme: 15% discount for bookings from 3 nights.'
        },
        buttons: {
            btn1: 'BOOK NOW',
            more: 'More about the room',
            hide: 'Hide'
        }
    },
    ru: {
        navigation: {
            rooms: 'Номера',
            food: 'Ресторан',
            confService: 'Конференц-сервис',
            service: 'Услуги',
            news: 'Новости',
            career: 'Карьера',
            contact: 'Контакты',
            booking: 'Бронирование',
            faq: 'FAQ',
            about: 'О нас'
        },
        booking: {
            title: 'Забронировать',
            label1: 'Заезд',
            label2: 'Выезд',
            label3: 'Гостей',
            guest: 'человек',
            guests: 'человека',
            discount: 'При броне на сайте'
        },
        videoSection: {
            description: ' — отель, расположенный в элитном\n' +
            '                        районе Одессы — самом сердце Аркадии. Gagarinn Hotel — это отдых в\n' +
            '                        непосредственной близости к пляжам, летним клубам,\n' +
            '                        фешенебельным ресторанам и главным достопримечательностям\n' +
            '                        города.',
            descriptionMob: 'К услугам гостей — бесплатный такси-трансфер,\n' +
            '                        Wi-Fi, собственная парковка, ресторан\n' +
            '                        Gagarinn Food Hub, торгово-развлекательный\n' +
            '                        центр Gagarinn Plaza. В отеле есть химчистка,\n' +
            '                        прачечная, камера хранения и сервис\n' +
            '                        обслуживания номеров Room Service 24/7.\n' +
            '                        На территории круглосуточно работает\n' +
            '                        лобби-бар с широкой коктейльной картой.',
            freeTransfer: 'Укажите при бронировании промокод BIRTHDAY',
            //freeTransfer: 'Здравствуйте! Gagarinn Hotel временно закрыт на период карантина, пожалуйста пишите нам на почту sales@gagarinn.com',
            freeTransfer2: 'и получите скидку',
            freeTransferMob: [
                {text: 'Укажите при бронировании промокод BIRTHDAY'},
                {text: 'и получите скидку'},
                //{text: 'промокод free'},
            ]
            /*freeTransferMob: [
                {text: 'Здравствуйте! Gagarinn Hotel временно закрыт на период карантина, '},
                {text: 'пожалуйста пишите нам на почту sales@gagarinn.com'},
                {text: 'и с вами свяжется наш менеджер'},
            ]*/
        },
        longStaySection: {
            title: 'Long Stay — длительное проживание',
            text1: 'Long Stay - программа для длительного визита в Gagarinn Hotel — минус 15% от цены номера!',
            text2: 'А чтобы сделать ваше пребывание еще более приятным, мы дарим гостям с детьми купон на одно бесплатное посещение нашего детского парка Gagarinn Kids, чтобы Ваши дети смогли насладиться увлекательными развлечениями!',
            moreBtn: 'Подробнее'
        },
        confSection: {
            title: 'Конференц-сервис',
            text1: 'На третьем и четвертом этажах Gagarinn Hotel расположен комплекс из 9\n' +
            '                    современных конференц-залов. Здесь можно арендовать помещение\n' +
            '                    для любого корпоративного или частного мероприятия: конференции,\n' +
            '                    презентации, семинара, тренинга, деловой встречи, тимбилдинга и не\n' +
            '                    только.',
            text2: ' Высокоскоростной Wi-Fi, вся мультимедийная и презентационная\n' +
            '                    техника, система кондиционирования с оптимальным температурным\n' +
            '                    режимом обеспечат продуктивную работу, а персонал окажет\n' +
            '                    необходимое сопровождение вашего мероприятия.',
            moreBtn: 'Подробнее',
            moreBtnLink: 'https://conference.gagarinn.com/'
        },
        kidsSection: {
            title: 'Free For Kids — бесплатное проживание для детей до 16 лет в Gagarinn Hotel',
            text1: 'Представляем уникальное предложение среди одесских отелей.',
            text2: 'Gagarinn Hotel стремится сделать семейный отдых более доступным и комфортным.\n' +
                    'Теперь при бронировании номеров категории Студия или Люкс, все дети до 16 лет\n' +
                    'смогут насладиться отдыхом в нашем отеле абсолютно бесплатно!',
            moreBtn: 'Подробнее',
        },
        fitnessSection: {
            title: 'Фитнес',
            text: 'Фитнес на реконструкции, но скоро увидимся',
            casinoTitle: 'Казино',
            casinoText: 'На 8-м этаже отеля Gagarinn вас уже ждут в First Casino:',
            casinoListItem1: '9 столов для игры в рулетку;',
            casinoListItem2: '40 карточных и покерных столов;',
            casinoListItem3: '300 слот-машин;',
            casinoListItem4: 'комфортабельные частные залы;',
            casinoListItem5: '3 бара и ресторан европейской кухни.',
            casinoText2: 'First Casino работает круглосуточно.',
        },
        foodSection: {
            title: 'Ресторан FoodHub',
            text1 : ' На втором этаже Gagarinn Hotel расположен ресторан Gagarinn Food\n' +
            '                    Hub на 300 посадочных мест. Это отличное место для проведения\n' +
            '                    бизнес-ланчей, корпоративных мероприятий и торжественных\n' +
            '                    событий. Здесь гостям предлагают блюда европейской, азиатской,\n' +
            '                    украинской и локальной одесской кухонь. Также к вашим услугам —\n' +
            '                    карта напитков, разнообразие шведского стола. Gagarinn Food Hub —\n' +
            '                    это абсолютно новый формат ресторана с исключительной\n' +
            '                    философией. Здесь Вы гарантированно получаете больше, чем\n' +
            '                    привыкли получать. Как от блюд, так и от сервиса.',
            text2: ' Ресторан угощает гостей завтраком каждый день с 8:00 до 23:00.',
            text3: 'Добро пожаловать в ресторан Gagarinn Food Hub на 2 этаже отеля Gagarinn.',
            moreBtn: 'Подробнее',
            menu: 'Меню',
            // link: '/pdf/menu.pdf',
            // link: 'https://gagarinn-food-hub.choiceqr.com/',
            link: 'https://smartspot.servio.support/ServioQR/restaurant?rID=9483910e-66d4-465e-821c-acd663d3cc2a&tableID=2837',
        },
        faqSection: {
            title: 'Часто задаваемые вопросы',
            question1: 'Где можно погладить вещи?',
            answer1: 'На 6-ом этаже находится гладильная комната. При выходе с лифта необходимо\n' +
                        'повернуть направо и возле служебного лифта расположена гладильная комната в доступе 24/7.',
            question2: 'Есть ли зарядное устройство и где его взять?',
            answer2: 'Зарядное устройство предоставляется на ресепшене.',
            question3: 'Можно ли выехать с номера и оставить где-то вещи? (Есть ли камера хранения?)',
            answer3: 'На 1-ом этаже расположена камера хранения. Для того, чтобы\n' +
                        'оставить вещи гостям необходимо обратиться на ресепшн. Хранение бесплатно до конца дня выезда.',
            question4: 'Есть ли у вас зоны для курения?',
            answer4: 'Зоны для курения расположены на 5-10-15 этажах в виде балкона в конце коридора. Курение в номерах запрещено.',
            question5: 'Есть ли пляжное полотенце, предоставляется ли?',
            answer5: 'Предоставляем пляжное полотенце по запросу гостя. Для этого необходимо обратиться на ресепшн.',
            question6: 'Есть ли аптечка?',
            answer6: 'Да, есть. Можем предоставить все кроме медикаментов.',
            question7: 'Куда обращаться за дополнительными бытовыми компонентами в номера:\n' +
                        'электрический чайник в номер и тд',
            answer7: 'За дополнительными бытовыми компонентами необходимо обратиться на ресепшн',
            question8: 'Как пройти в ресторан?',
            answer8: 'Ресторан находится на 2-ом этаже. Номер телефона для бронирования столов',
            question9: 'Условия раннего заезда?',
            answer9: 'С октября по май: до 06:00 100% от суточного тарифа, после 06:00 50% от суточного тарифа.\n' +
                        'С июня по сентябрь: до стандартного времени поселения (14:00) 100% от суточного тарифа.',
            question10: 'Где провести время с ребенком?',
            answer10_1: 'На территории гостиничного комплекса имеются детские развлекательные центры: город профессий «KIDS CITY» и батутный парк «KIDS PLANET».',
            question11: 'Можно ли проживать с животными?',
            answer11_1: 'В отеле разрешается проживание с домашними животными: собаками и котами. Размещение гостей с другими животными согласовывается с дирекцией отеля дополнительно.',
            answer11_2: 'Стоимость размещения за животное:',
            answer11_3: '*до 50 см с загривком - 500,00 грн/сутки и залог за животное - 2500 грн. (на весь срок проживания).',
            answer11_4: '*свыше 50 см с хохолком - 800,00 грн/сутки и залог за животное - 5000 грн. (на весь срок проживания).',
            answer11_5: 'Указанная сумма предназначена для специальной уборки номера после отъезда гостя с домашними животными.',
            answer11_6: 'Гостю с животным предоставляется на безвозмездной основе:',
            answer11_7: 'миска;',
            answer11_8: 'одноразовая пеленка;',
            answer11_9: 'лежанка.'
        },
        contactSection: {
            title: 'Контакты',
            blocks: {
                addres:{
                    title: 'Адрес',
                    data: [
                        { type: 'text', isActive: false, text: '65009, Украина, г. Одесса, ул. Аркадийское плато, 5Б' }
                    ]
                },
                conference: {
                    title: 'Конференц-сервис',
                    data: [
                        { type: 'phone', isActive: true, text: '+38 (073) 774 44 73 (24/7)', callTrackingId: '3', val: '0737744473' },
                        { type: 'phone', isActive: true, text: '+38 (093) 536 03 16', callTrackingId: '8', val: '0935360316' },
                        { type: 'email', isActive: true, text: 'conference@gagarinn.com' },
                        { type: 'email', isActive: true, text: 'sales@gagarinn.com' }
                    ]
                },
                booking: {
                    title: 'Бронирование',
                    data: [
                        { type: 'phone', isActive: true, text: '+38 (073) 774 44 73', callTrackingId: '3', val: '0737744473' },
                        { type: 'phone', isActive: true, text: '+38 (048) 774 44 73', callTrackingId: '3', val: '0487744473' },
                        { type: 'phone', isActive: true, text: '+38 (063) 735 44 18', callTrackingId: '3', val: '0637354418' },
                        { type: 'email', isActive: true, text: 'sales@gagarinn.com' }
                    ]
                },
                food_hub: {
                    title: 'Food Hub',
                    data: [
                        { type: 'phone', isActive: true, text: '+38 (063) 735 20 60', callTrackingId: '6',val: '0637352060' },
                        { type: 'text', isActive: false, text: 'ул. Генуэзская, 5' }
                    ]
                },
                child:{
                    title: 'Gagarinn Kids',
                    data: [
                        { type: 'phone', isActive: true, text: '+38 (093) 170 70 10', callTrackingId: '7',val: '0931707010' },
                        { type: 'text', isActive: false, text: 'ул. Генуэзская, 5' }
                    ]
                },
                mall:{
                    title: 'ТРК Gagarinn Plaza',
                    data: [
                        { type: 'phone', isActive: true, text: '+38 (093) 330 09 89', callTrackingId: '',val: '0933300989' },
                        { type: 'phone', isActive: true, text: '+38 (093) 330 13 75', callTrackingId: '',val: '0933301375' },
                    ]
                },
                // kidswill:{
                //     title: 'Kidswill',
                //     data: [
                //         { type: 'phone', isActive: true, text: '+38 (093) 088 66 64', callTrackingId: '',val: '0930886664' },
                //         { type: 'phone', isActive: true, text: '+38 (093) 088 66 69', callTrackingId: '',val: '0930886669' },
                //     ]
                // },
                policy: {
                    data: [
                        { type: 'link', isActive: true, text: 'Политика конфиденциальности', callTrackingId: '', link: '/pdf/privacy_ua.pdf' },
                        { type: 'link', isActive: true, text: 'Публичная оферта', callTrackingId: '', link: '/pdf/agreement_ua.pdf' },
                        { type: 'link', isActive: true, text: 'О нас', callTrackingId: '', link: '/pdf/presentation_ua.pdf' },
                    ]
                }
            }

        },
        services: {
            services: 'Услуги',
            arrival: 'Заселение с 14:00',
            departure: 'Выселение в 11:00',
            concierge: 'Консьерж-сервис',
            laundry: 'Прачечная',
            restaurant: 'Ресторан Food Hub',
            restaurant_full: 'Ресторан европейской, японской и украинской кухни Food Hub',
            lobby: 'Лобби-бар 24/7',
            roomService: 'Круглосуточный Room Servise',
            conferenceService: 'Конференц-сервис',
            mall: 'торгово-развлекательный центр',
            pet: 'Pet Friendly'
        },
        bathroom: {
            bathroom: 'Ванная комната',
            shower: 'душ',
            bath: 'ванна',
            hairdryer: 'фен',
            towels: 'полотенца',
            bath_robes: 'халаты',
            slippers: 'тапочки',
            toiletries: 'средства гигиены',
        },
        accommodation: {
            accommodation: 'В номере',
            double_bed: 'двуспальная кровать',
            two_beds: 'две односпальные кровати',
            conditioner: 'кондиционер',
            tv: 'телевизор',
            telephone: 'телефон',
            safe: 'сейф',
            minibar: 'мини-бар',
            luggage: 'багажная тумба',
            hangers: 'вешалки',
            secretaire: 'письменный стол',
            chair: 'стул',
            mirror: 'зеркало',
            mirror_big: 'зеркало',
            wardrobe: 'шкаф для одежды',
            wifi: 'WI-FI',
            kingsize: 'кровать King Size',
            sofa: 'раскладной диван',
            table: 'журнальный стол',
            anteroom: 'прихожая',
        },
        roomStandard: {
            title: 'Стандарт',
            textTop: ' Однокомнатный номер со всеми удобствами. Доступен в нескольких\n' +
            '                        вариациях: с двуспальной кроватью либо двумя односпальными.\n' +
            '                        Стандартные номера расположены на 4-5 этажах отеля. Из окон\n' +
            '                        номера открывается вид на ТРК Gagarinn Plaza.',
            priceTitle: 'Цена',
            priceDescription: 'грн',
            areaTitle: 'Площадь',
            areaDescription: 'м2',
            guests: 'Гостей',
            guestDescription: 'чел',
            subTitle1: 'В номере',
            subDescription1: ' Одна двуспальная кровать/две односпальных кровати,\n' +
            '                                    Письменный стол,  Кондиционер, Телевизор,  Телефон,\n' +
            '                                    Сейф, Мини-бар, Багажная тумба,  Вешалки,  Стул,\n' +
            '                                    Гардеробнй шкаф, Зеркало,  WI-FI',
            subTitle2: 'В ванной комнате',
            subDescription2: ' Душ,  Фен,  Полотенца,  Тапочки\n' +
            '                                    Средства гигиены',
            subTitle3: 'Услуги',
            subDescription3: 'Заселение в 14:00, Выселение в 11:00,\n' +
            '                                    Консьерж-сервис, Прачечная/химчистка, Ресторан\n' +
            '                                    европейской, японской и украинской кухни\n' +
            '                                    Food Hub, Лобби-бар 24/7, Круглосуточный Room\n' +
            '                                    Servise, Конференц-сервис, Т\n' +
            '                                    оргово-развлекательный центр',
        },
        roomDeluxe: {
            title: 'Улучшенный',
            textTop: ' Номер с современной мебелью и уютной обстановкой. Возможно\n' +
            '                        комфортное размещение гостей на одной двуспальной либо на 2-х\n' +
            '                        односпальных кроватях. Номера этой категории расположены с 6 по\n' +
            '                        18 этаж.',
            priceTitle: 'Цена',
            priceDescription: 'грн',
            areaTitle: 'Площадь',
            areaDescription: 'м2',
            guests: 'Гостей',
            guestDescription: 'чел',
            subTitle1: 'В номере',
            subDescription1: 'Oдна двуспальная кровать/две односпальных кровати,\n' +
            '                                    Kондиционер, Телевизор, Телефон, Сейф, Мини-бар,\n' +
            '                                    Багажная тумба, Вешалки, Письменный стол, Стул,\n' +
            '                                    Зеркало, Шкаф для одежды, WI-FI',
            subTitle2: 'В ванной комнате',
            subDescription2: ' Душ,  Фен,  Полотенца,  Тапочки\n' +
            '                                    Средства гигиены',
            subTitle3: 'Услуги',
            subDescription3: 'Заселение в 14:00, Выселение в 11:00,\n' +
            '                                    Консьерж-сервис, Прачечная/химчистка, Ресторан\n' +
            '                                    европейской, японской и украинской кухни\n' +
            '                                    Food Hub, Лобби-бар 24/7, Круглосуточный Room\n' +
            '                                    Servise, Конференц-сервис, Торгово-развлекательный центр',
        },
        roomLux: {
            title: 'Люкс',
            textTop: '  Двухкомнатный номер, выполненный в европейском стиле. Из окон\n' +
            '                        открывается панорамный вид на город. Расположение\n' +
            '                        номеров: 4-19 этажи. Номер оборудован современной техникой,\n' +
            '                        мебелью, в том числе, большой двуспальной или двумя односпальными  кроватями.',
            priceTitle: 'Цена',
            priceDescription: 'грн',
            areaTitle: 'Площадь',
            areaDescription: 'м2',
            guests: 'Гостей',
            guestDescription: 'чел',
            subTitle1: 'В номере',
            subDescription1: 'Кровать King Size, Раскладной диван,  Журнальный\n' +
            '                                    столик,  Письменный стол,  Кондиционер,\n' +
            '                                    Телевизор,  Телефон, Сейф Мини-бар, Багажная\n' +
            '                                    тумба,  Вешалки,  Стул,  Гардеробнй шкаф,  Большое\n' +
            '                                    зеркало,  WI-FI',
            subTitle2: 'В ванной комнате',
            subDescription2: 'Душ/ванна,  Фен,  Полотенца,  Халаты,  Тапочки\n' +
            '                                    Средства гигиены',
            subTitle3: 'Услуги',
            subDescription3: 'Заселение в 14:00, Выселение в 11:00,\n' +
            '                                    Консьерж-сервис, Прачечная/химчистка, Ресторан\n' +
            '                                    европейской, японской и украинской кухни\n' +
            '                                    Food Hub, Лобби-бар 24/7, Круглосуточный Room\n' +
            '                                    Servise, Конференц-сервис, Торгово-развлекательный\n' +
            '                                    центр',
        },
        roomStudio: {
            title: 'Студия',
            textTop: ' Просторный однокомнатный номер в стиле минимализм, разделённый\n' +
            '                        на две зоны: спальную и гостиную. Номер оборудован современной\n' +
            '                        техникой и мебелью. Из окон открывается вид на панораму города и\n' +
            '                        море. Номера категории Студия располагаются на 8 и 19 этажах отеля.',
            priceTitle: 'Цена',
            priceDescription: 'грн',
            areaTitle: 'Площадь',
            areaDescription: 'м2',
            guests: 'Гостей',
            guestDescription: 'чел',
            subTitle1: 'В номере',
            subDescription1: 'Кровать King Size, Раскладной диван,  Журнальный\n' +
            '                                    столик,  Письменный стол,  Кондиционер,\n' +
            '                                    Телевизор,  Телефон, Сейф Мини-бар, Багажная\n' +
            '                                    тумба,  Вешалки,  Стул,  Гардеробнй шкаф,  Большое\n' +
            '                                    зеркало,  WI-FI',
            subTitle2: 'В ванной комнате',
            subDescription2: 'Душевая,  Фен,  Полотенца,  Халат,  Тапочки,\n' +
            '                                    Средства гигиены',
            subTitle3: 'Услуги',
            subDescription3: 'Заселение в 14:00, Выселение в 11:00,\n' +
            '                                    Консьерж-сервис, Прачечная/химчистка, Ресторан\n' +
            '                                    европейской, японской и украинской кухни\n' +
            '                                    Food Hub, Лобби-бар 24/7, Круглосуточный Room\n' +
            '                                    Servise, Конференц-сервис, Торгово-развлекательный\n' +
            '                                    центр',
        },
        roomFamily: {
            title: 'Семейный Люкс',
            textTop: '  Трехкомнатный номер, выполненный в европейском стиле, с\n' +
              '                        двумя раздельными спальнями. Из окон открывается панорамный вид на море\n' +
              '                        и город. Расположение номеров на 13 этаже. Номер оборудован современной\n' +
              '                        техникой, мебелью, большой двуспальной кроватью в каждой спальной\n' +
              '                        комнате, а также большим раскладным диваном в гостиной. В номере имеются\n' +
              '                        два раздельных санузла: один с душевой кабиной, второй — с ванной.',
            priceTitle: 'Цена',
            priceDescription: 'грн',
            areaTitle: 'Площадь',
            areaDescription: 'м2',
            guests: 'Гостей',
            guestDescription: 'чел',
            subTitle1: 'В номере',
            subDescription1: 'Кровать King Size, Раскладной диван,  Журнальный\n' +
              '                                    столик,  Письменный стол,  Кондиционер,\n' +
              '                                    Телевизор,  Телефон, Сейф Мини-бар, Багажная\n' +
              '                                    тумба,  Вешалки,  Стул,  Гардеробнй шкаф,  Большое\n' +
              '                                    зеркало,  WI-FI',
            subTitle2: 'В ванной комнате',
            subDescription2: 'Душ/ванна,  Фен,  Полотенца,  Халаты,  Тапочки\n' +
              '                                    Средства гигиены',
            subTitle3: 'Услуги',
            subDescription3: 'Заселение в 14:00, Выселение в 11:00,\n' +
              '                                    Консьерж-сервис, Прачечная/химчистка, Ресторан\n' +
              '                                    европейской, японской и украинской кухни\n' +
              '                                    Food Hub, Лобби-бар 24/7, Круглосуточный Room\n' +
              '                                    Servise, Конференц-сервис, Торгово-развлекательный\n' +
              '                                    центр',
        },
        longStayModal: {
            p1: 'Отель Gagarinn предлагает комфортабельные условия для длительного проживания, чтобы вы смогли почувствовать настоящий домашний уют во время поездки',
            p2: 'Одно из наших особых предложений для вас — скидка на проживание в размере 15%*, если вы бронируете номер на 5 ночей или более. Таким образом, вы можете сэкономить еще больше на вашем отдыхе. Пожалуйста, обратите внимание, что минимальный срок проживания по этому тарифу составляет 5 дней.',
            p3: 'В стоимость вашего номера также включен Wi-Fi, чтобы вы могли оставаться на связи и наслаждаться высокоскоростным интернетом в любое время.',
            // p4: 'Мы предлагаем размещение детей до 6 лет бесплатно в одном номере с родителями, без предоставления дополнительного спального места. А для самых маленьких - детей до 3 лет, мы рады предложить детскую кроватку во всех категориях номеров без дополнительной оплаты.',
            // p5: 'Мы предлагаем бесплатное проживание для самых маленьких - детей до 16 лет при бронировании семейных номеров категории Студия или Люкс, и с удовольствием предоставляем детскую кроватку во всех категориях номеров без дополнительной оплаты.',
            p6: 'И чтобы сделать ваше пребывание еще более приятным, мы дарим гостям с детьми купон на одно бесплатное посещение нашего детского парка Gagarinn Kids, чтобы Ваши дети смогли насладиться увлекательными развлечениями!',
            p7: 'Для вашего удобства, в наших номерах категории "Люкс" и "Студия" доступны два дополнительных места в виде раскладного дивана. Дополнительное место стоит 500,00 грн для детей от 7 до 11 лет и 750 грн для детей от 12 лет и взрослых за человека в сутки, без завтрака.',
            p8: 'Также хотим порадовать вас специальными ценами на завтраки в формате шведского стола:',
            p9: 'Дети до 3 лет: бесплатные завтраки',
            p10: 'Дети от 3 до 12 лет: 300 грн',
            p11: 'От 12 лет и для взрослых: 400 грн',
            p12: 'Мы стремимся сделать ваше длительное проживание в Gagarinn Hotel максимально комфортным и приятным. Предоставляя особые условия, мы надеемся, что вы почувствуете себя как дома.',
            p13: '*Туристический сбор в размере 40,00 грн. с человека в день не входит в стоимость проживания и должен быть оплачен дополнительно.'
        },
        kidsModal: {
            p1: 'Мы рады объявить о введении новой выгодной акции для семей с детьми. Теперь при бронировании номеров категории Студия или Люкс, все дети до 16 лет смогут насладиться отдыхом в нашем отеле абсолютно бесплатно!*',
            p2: 'Основной целью Gagarinn Hotel является обеспечение комфорта и предоставление сервиса наивысшего уровня для всех гостей, особенно для младших членов семьи. Бесплатное проживание для детей — это прекрасная возможность потратить больше на развлечения и впечатления во время вашего семейного отдыха!*',
            p3: 'Также хотим порадовать вас специальными ценами на завтраки в формате шведского стола:',
            p4: 'Дети до 3 лет: бесплатные завтраки',
            p5: 'Дети от 3 до 12 лет: 300 грн',
            p6: 'От 12 лет и для взрослых: 400 грн',
            p7: 'Не упустите возможность посетить Gagarinn Hotel и получить незабываемые впечатления от семейного отдыха в Одессе! Забронируйте номер уже сегодня и создавайте моменты, которые запоминаются навсегда. Начните планировать Вашу поездку прямо сейчас!',
            p8: '*Независимо от количества детей в семье.',
            p9: '**Предложение суммируется с акцией "Long Stay" — скидкой 15% на проживание в отеле от 3 ночей.'
        },
        buttons: {
            btn1: 'Забронировать',
            more: 'Подробнее о номере',
            hide: 'Скрыть'
        }
    },
    uk: {
        navigation: {
            rooms: 'Номери',
            food: 'Ресторан',
            confService: 'Конференц-сервіс',
            service: 'Послуги',
            news: 'Новини',
            career: 'Кар\'єра',
            contact: 'Контакти',
            booking: 'Бронювання',
            faq: 'FAQ',
            about: 'Про нас'
        },
        booking: {
            title: 'Забронювати',
            label1: 'Заїзд',
            label2: 'Виїзд',
            label3: 'Гостей',
            guest: 'людина',
            guests: 'людей',
            discount: 'При бронюванні на сайті'
        },
        videoSection: {
            description: ' — готель, розміщений в елітному\n' +
            '                        районі Одеси — самому сердці Аркадії. Gagarinn Hotel — це відпочинок в\n' +
            '                        безпосередній близькості до пляжів, літніх клубів,\n' +
            '                        фешенебельних ресторанів і головних пам\'яток\n' +
            '                        міста.',
            descriptionMob: 'До послуг гостей — безкоштовний таксі-трансфер,\n' +
            '                        Wi-Fi, власний паркінг, ресторан\n' +
            '                        Gagarinn Food Hub, торгово-розважальний\n' +
            '                        центр Gagarinn Plaza. В готелі є хімчистка,\n' +
            '                        пральня, камери схову та сервіс\n' +
            '                        обслуговування номерів Room Service 24/7.\n' +
            '                        На території цілодобово працює\n' +
            '                        лобі-бар з широкою коктейльною картою.',
            freeTransfer: 'Вкажіть промокод BIRTHDAY при бронюванні та отримайте знижку',
            //freeTransfer: 'Здравствуйте! Gagarinn Hotel временно закрыт на период карантина, пожалуйста пишите нам на почту sales@gagarinn.com',
            //freeTransfer2: 'і з вами зв\'яжеться наш менеджер',
            freeTransferMob: [
                {text: 'Вкажіть промокод BIRTHDAY'},
                {text: 'при бронюванні'},
                {text: 'та отримайте знижку'},
            ]
            /*freeTransferMob: [
                {text: 'Здравствуйте! Gagarinn Hotel временно закрыт на период карантина, '},
                {text: 'пожалуйста пишите нам на почту sales@gagarinn.com'},
                {text: 'и с вами свяжется наш менеджер'},
            ]*/
        },
        longStaySection: {
            title: 'Long Stay — тривале проживання',
            text1: 'Long Stay —  програма для довготривалого візиту в Gagarinn Hotel — мінус 15% від ціни номеру!*',
            text2: 'А щоб зробити ваше перебування ще більш приємним, ми даруємо гостям з дітьми купон на одне безкоштовне відвідування нашого дитячого парку Gagarinn Kids, щоб Ваші діти змогли насолодитися захопливими розвагами!',
            moreBtn: 'Детальніше'
        },
        confSection: {
            title: 'Конференц-сервіс',
            text1: 'На третьому та четвертому поверхах Gagarinn Hotel розташований комплекс з 9\n' +
            '                    сучасних конференц-залів. Тут можна орендувати приміщення\n' +
            '                    для будь-якого корпоративного чи приватного заходу: конференції,\n' +
            '                    презентації, семінару, тренінгу, ділової зустрічі, тімбілдингу і не\n' +
            '                    тільки.',
            text2: ' Високошвидкісний Wi-Fi, уся мультимедійна і презентаційна\n' +
            '                    техніка, система кондиціонування з оптимальним температурним\n' +
            '                    режимом забезпечать продуктивну роботу, а персонал надасть\n' +
            '                    необхідний супровід вашого заходу.',
            moreBtn: 'Детальніше',
            moreBtnLink: 'https://conference.gagarinn.com/ua'
        },
        kidsSection: {
            title: 'Free For Kids — безоплатне проживання для дітей до 16 років в Gagarinn Hotel',
            text1: 'Презентуємо унікальну пропозицію серед одеських готелів.',
            text2: 'Gagarinn Hotel прагне зробити сімейний відпочинок більш доступним та комфортним.\n' +
                    'Відтепер, при бронюванні номерів категорії Студія або Люкс, всі діти до 16 років\n' +
                    'зможуть насолодитися відпочинком в нашому готелі абсолютно безоплатно',
            moreBtn: 'Детальніше',
        },
        fitnessSection: {
            title: 'Фітнес',
            text: 'Фітнес ще на реконструкції, але незабаром побачимося',
            casinoTitle: 'Казино',
            casinoText: 'На 8-му поверсі готелю Gagarinn на вас вже чекають у First Casino:',
            casinoListItem1: '9 столів для гри в рулетку;',
            casinoListItem2: '40 карткових та покерних столиків;',
            casinoListItem3: '300 слот-машин;',
            casinoListItem4: 'комфортабельні приватні зали;',
            casinoListItem5: '3 бари та ресторан європейської кухні.',
            casinoText2: 'First Casino працює цілодобово.',
        },
        foodSection: {
            title: 'Ресторан FoodHub',
            text1 : ' На другому поверсі Gagarinn Hotel розташований ресторан Gagarinn Food\n' +
            '                    Hub на 300 посадочних місць. Це відмінне місце для проведення\n' +
            '                    бізнес-ланчів, корпоративних заходів і урочистих\n' +
            '                    подій. Тут гостям пропонують страви європейської, азійської,\n' +
            '                    української і локальної одеської кухні. Також до ваших послуг —\n' +
            '                    карта напоїв, різноманіття шведського столу. Gagarinn Food Hub —\n' +
            '                    це абсолютно новий формат ресторану з виключною\n' +
            '                    філософією. Тут Ви гарантовано отримаєте більше, ніж\n' +
            '                    звикли. Як від страв, так і від сервісу.',
            text2: ' Ресторан пригощає гостей сніданком кожного дня з 8:00 до 23:00.',
            text3: 'Ласкаво просимо в ресторан Gagarinn Food Hub на 2 поверсі готелю Gagarinn.',
            moreBtn: 'Детальніше',
            menu: 'Меню',
            // link: '/pdf/menu.pdf',
            // link: 'https://gagarinn-food-hub.choiceqr.com/',
            link: 'https://smartspot.servio.support/ServioQR/restaurant?rID=9483910e-66d4-465e-821c-acd663d3cc2a&tableID=2837',
        },
        faqSection: {
            title: 'Поширені запитання',
            question1: 'Де можна прасувати речі?',
            answer1: 'На 6 поверсі знаходиться кімната для прасування. При виході з ліфту необхідно\n' +
                'повернути праворуч та біля службового ліфту розташована кімната для прасування в доступі 24/7.',
            question2: 'Чи є зарядний пристрій та де можна його взяти?',
            answer2: 'Зарядний пристрій надається на рецепції',
            question3: 'Чи можна виїхати з номеру та десь залишити речі (Чи є камера схову?)',
            answer3: 'На 1 поверсі розташована камера схову. Для того, щоб\n' +
                'залишити речі відвідувачі повинні звернутися на рецепцію. Зберігання речей безкоштовно до кінця дня виїзду.',
            question4: 'Чи є у вас зони для куріння?',
            answer4: 'Зони для куріння розташовані на 5, 10, 15 поверхах у вигляді балкона в кінці коридору. Куріння в номерах заборонено.',
            question5: 'Чи є пляжний рушник, чи надає готель в оренду?',
            answer5: 'Надаємо пляжний рушник за запитом гостя. Для цього необхідно звернутися на рецепцію.',
            question6: 'Чи є аптечка ?',
            answer6: 'Так, є. Можемо надати всі крім медикаментів.',
            question7: 'Куди звертатися за додатковими побутовими компонентами в номери?\n' +
                'Електричний чайник в номер і тд?',
            answer7: 'За додатковими побутовими компонентами необхідно звернутися на рецепцію',
            question8: 'Як пройти в ресторан?',
            answer8: 'Ресторан знаходиться на 2-му поверсі. Номер телефону для бронювання столиків',
            question9: 'Які умови раннього заїзду?',
            answer9: 'З жовтня до травня: до 06:00 100% від добового тарифу, після 6:00 50% від добового тарифу.\n' +
                'З червня до вересня до стандартного часу поселення (14:00) 100% від добового тарифу.',
            question10: 'Де провести час з дитиною?',
            answer10_1: 'На території готельного комплексу є дитячі розважальні центри: місто професій "KIDS CITY" та батутний парк "KIDS PLANET".',
            question11: 'Чи можна проживати з тваринами?',
            answer11_1: 'У готелі дозволяється проживання з домашніми тваринами, а саме: собаками та котами. Розміщення гостей з іншими тваринами погоджується з дирекцією готелю додатково.',
            answer11_2: 'Вартість розміщення за тварину:',
            answer11_3: '*до 50 см із загривком – 500,00 грн/добу та застава за тварину  - 2500 грн. (на весь термін проживання).',
            answer11_4: '*понад 50 см із загривком - 800,00 грн/добу та застава за тварину -  5000 грн. (на весь термін проживання).',
            answer11_5: 'Вказана сума призначена для спеціального прибирання номера після від\'їзду гостя з домашніми тваринами.',
            answer11_6: 'Гостю з твариною надається на безоплатній основі:',
            answer11_7: 'миска;',
            answer11_8: 'одноразова пелюшка;',
            answer11_9: 'лежанка.'
        },
        contactSection: {
            title: 'Контакти',
            blocks: {
                addres:{
                    title: 'Адреса',
                    data: [
                        { type: 'text', isActive: false, text: '65009, Україна, м. Одеса, вул. Аркадійське плато, 5Б' }
                    ]
                },
                conference: {
                    title: 'Конференц-сервіс',
                    data: [
                        { type: 'phone', isActive: true, text: '+38 (073) 774 44 73 (24/7)', callTrackingId: '3', val: '0737744473' },
                        { type: 'phone', isActive: true, text: '+38 (093) 536 03 16', callTrackingId: '8', val: '0935360316' },
                        { type: 'email', isActive: true, text: 'conference@gagarinn.com' },
                        { type: 'email', isActive: true, text: 'sales@gagarinn.com' }
                    ]
                },
                booking: {
                    title: 'Бронювання',
                    data: [
                        { type: 'phone', isActive: true, text: '+38 (073) 774 44 73', callTrackingId: '3', val: '0737744473' },
                        { type: 'phone', isActive: true, text: '+38 (048) 774 44 73', callTrackingId: '3', val: '0487744473' },
                        { type: 'phone', isActive: true, text: '+38 (063) 735 44 18', callTrackingId: '3', val: '0637354418' },
                        { type: 'email', isActive: true, text: 'sales@gagarinn.com' }
                    ]
                },
                food_hub: {
                    title: 'Food Hub',
                    data: [
                        { type: 'phone', isActive: true, text: '+38 (063) 735 20 60', callTrackingId: '6',val: '0637352060' },
                        { type: 'text', isActive: false, text: 'вул. Генуезька, 5' }
                    ]
                },
                child:{
                    title: 'Gagarinn Kids',
                    data: [
                        { type: 'phone', isActive: true, text: '+38 (093) 170 70 10', callTrackingId: '7',val: '0931707010' },
                        { type: 'text', isActive: false, text: 'вул. Генуезька, 5' }
                    ]
                },
                mall:{
                    title: 'ТРК Gagarinn Plaza',
                    data: [
                        { type: 'phone', isActive: true, text: '+38 (093) 330 09 89', callTrackingId: '',val: '0933300989' },
                        { type: 'phone', isActive: true, text: '+38 (093) 330 13 75', callTrackingId: '',val: '0933301375' },
                    ]
                },
                // kidswill:{
                //     title: 'Kidswill',
                //     data: [
                //         { type: 'phone', isActive: true, text: '+38 (093) 088 66 64', callTrackingId: '',val: '0930886664' },
                //         { type: 'phone', isActive: true, text: '+38 (093) 088 66 69', callTrackingId: '',val: '0930886669' },
                //     ]
                // },
                policy: {
                    data: [
                        { type: 'link', isActive: true, text: 'Політика конфіденційності', callTrackingId: '', link: '/pdf/privacy_ua.pdf' },
                        { type: 'link', isActive: true, text: 'Публічна оферта', callTrackingId: '', link: '/pdf/agreement_ua.pdf' },
                        { type: 'link', isActive: true, text: 'Про нас', callTrackingId: '', link: '/pdf/presentation_ua.pdf' },
                    ]
                }
            }

        },
        services: {
            services: 'Послуги',
            arrival: 'Заселення з 14:00',
            departure: 'Виселення о 11:00',
            concierge: 'Конс\'єрж-сервіс',
            laundry: 'Пральня',
            restaurant: 'Ресторан Food Hub',
            restaurant_full: 'Ресторан європейської, японської та української кухні Food Hub',
            lobby: 'Лобі-бар 24/7',
            roomService: 'Цілодобовий Room Servise',
            conferenceService: 'Конференц-сервіс',
            mall: 'торгово-розважальний центр',
            pet: 'Pet Friendly'
        },
        bathroom: {
            bathroom: 'Ванна кімната',
            shower: 'душ',
            bath: 'ванна',
            hairdryer: 'фен',
            towels: 'рушники',
            bath_robes: 'халати',
            slippers: 'капці',
            toiletries: 'засоби гігієни',
        },
        accommodation: {
            accommodation: 'У номері',
            double_bed: 'двоспальне ліжко',
            two_beds: 'два односпальні ліжка',
            conditioner: 'кондиціонер',
            tv: 'телевізор',
            telephone: 'телефон',
            safe: 'сейф',
            minibar: 'міні-бар',
            luggage: 'багажна тумба',
            hangers: 'вішалки',
            secretaire: 'письмовий стіл',
            chair: 'стілець',
            mirror: 'дзеркало',
            mirror_big: 'дзеркало',
            wardrobe: 'шафа для одягу',
            wifi: 'WI-FI',
            kingsize: 'ліжко King Size',
            sofa: 'розкладний диван',
            table: 'журнальний стіл',
            anteroom: 'передпокій',
        },
        roomStandard: {
            title: 'Стандарт',
            textTop: 'Однокімнатний номер зі всіма зручностями. Доступний в кількох\n' +
            '                        варіаціях: з двоспальним ліжком або двома односпальними.\n' +
            '                        Стандартні номери розташовані на 4-5 поверхах готелю. Із вікон\n' +
            '                        номера відкривається вид на ТРК Gagarinn Plaza.',
            priceTitle: 'Ціна',
            priceDescription: 'грн',
            areaTitle: 'Площа',
            areaDescription: 'м2',
            guests: 'Гостей',
            guestDescription: '',
            subTitle1: 'В номері',
            subDescription1: ' Одне двоспальне ліжко/два односпальних ліжка,\n' +
            '                                    Письмовий стіл, Кондиціонер, Телевізор, Телефон,\n' +
            '                                    Сейф, Міні-бар, Багажна тумба,  Вішалки,  Стілець,\n' +
            '                                    Гардеробна шафа, Дзеркало,  WI-FI',
            subTitle2: 'В ванній кімнаті',
            subDescription2: ' Душ,  Фен,  Рушники,  Капці\n' +
            '                                    Засоби гігієни',
            subTitle3: 'Послуги',
            subDescription3: 'Заселення в 14:00, Виселення в 11:00,\n' +
            '                                    Конс\'єрж-сервис, Пральня/хімчистка, Ресторан\n' +
            '                                    європейської, японської та української кухні\n' +
            '                                    Food Hub, Лобі-бар 24/7, Цілодобовий Room\n' +
            '                                    Servise, Конференц-сервіс, Т\n' +
            '                                    оргово-розважальний центр',
        },
        roomDeluxe: {
            title: 'Покращений',
            textTop: ' Номер з сучасними меблями та затишною атмосферою. Можливе\n' +
            '                        комфортне розміщення гостей на одному двоспальному або на 2-х\n' +
            '                        односпальних ліжках. Номери цієї категорії розташовані з 6 по\n' +
            '                        18 поверх.',
            priceTitle: 'Ціна',
            priceDescription: 'грн',
            areaTitle: 'Площа',
            areaDescription: 'м2',
            guests: 'Гостей',
            guestDescription: '',
            subTitle1: 'В номері',
            subDescription1: 'Oдне двоспальне ліжко/два односпальних ліжка,\n' +
            '                                    Kондиціонер, Телевізор, Телефон, Сейф, Міні-бар,\n' +
            '                                    Багажна тумба, Вішалки, Письмовий стіл, Стілець,\n' +
            '                                    Дзеркало, Шафа для одягу, WI-FI',
            subTitle2: 'В ванній кімнаті',
            subDescription2: ' Душ,  Фен,  Рушники,  Капці\n' +
            '                                    Засоби гігієни',
            subTitle3: 'Послуги',
            subDescription3: 'Заселення в 14:00, Виселення в 11:00,\n' +
            '                                    Конс\'єрж-сервіс, Пральня/хімчистка, Ресторан\n' +
            '                                    європейської, японської та української кухні\n' +
            '                                    Food Hub, Лобі-бар 24/7, Цілодобовий Room\n' +
            '                                    Servise, Конференц-сервіс, Торгово-розважальний центр',
        },
        roomLux: {
            title: 'Люкс',
            textTop: '  Двокімнатний номер, виконаний в європейському стилі. Із вікон\n' +
            '                        відкривається панорамний вид на місто. Розташування\n' +
            '                        номерів: 4-19 поверхи. Номер обладнаний сучасною технікою,\n' +
            '                        меблями, в тому числі, великим двоспальним або двома односпальними ліжками.',
            priceTitle: 'Ціна',
            priceDescription: 'грн',
            areaTitle: 'Площа',
            areaDescription: 'м2',
            guests: 'Гостей',
            guestDescription: '',
            subTitle1: 'В номері',
            subDescription1: 'Ліжко King Size, Розкладний диван,  Журнальний\n' +
            '                                    столик,  Письмовий стіл,  Кондиціонер,\n' +
            '                                    Телевізор,  Телефон, Сейф Міні-бар, Багажна\n' +
            '                                    тумба,  Вішалки,  Стілець,  Гардеробна шафа,  Велике\n' +
            '                                    дзеркало,  WI-FI',
            subTitle2: 'В ванній кімнаті',
            subDescription2: 'Душ/ванна,  Фен,  Рушники,  Халати,  Капці\n' +
            '                                    Засоби гігієни',
            subTitle3: 'Послуги',
            subDescription3: 'Заселення в 14:00, Виселення в 11:00,\n' +
            '                                    Конс\'єрж-сервіс, Пральня/хімчистка, Ресторан\n' +
            '                                    європейської, японської та української кухні\n' +
            '                                    Food Hub, Лобі-бар 24/7, Цілодобовий Room\n' +
            '                                    Servise, Конференц-сервіс, Торгово-розважальний\n' +
            '                                    центр',
        },
        roomStudio: {
            title: 'Студія',
            textTop: ' Просторий однокімнатний номер в стилі мінімалізм, розділений\n' +
            '                        на дві зони: спальну та вітальну. Номер оснащений сучасною\n' +
            '                        технікою та меблями. Із вікон відкривається вид на панораму міста і\n' +
            '                        море. Номери категорії Студія розташовані на 8 і 19 поверхах готеля.',
            priceTitle: 'Ціна',
            priceDescription: 'грн',
            areaTitle: 'Площа',
            areaDescription: 'м2',
            guests: 'Гостей',
            guestDescription: '',
            subTitle1: 'В номері',
            subDescription1: 'Ліжко King Size, Розкладний диван,  Журнальний\n' +
            '                                    столик,  Письмовий стіл,  Кондиціонер,\n' +
            '                                    Телевізор,  Телефон, Сейф Міні-бар, Багажна\n' +
            '                                    тумба,  Вішалки,  Стілець,  Гардеробна шафа,  Велике\n' +
            '                                    дзеркало,  WI-FI',
            subTitle2: 'В ванній кімнаті',
            subDescription2: 'Душ,  Фен,  Рушники,  Халат,  Капці,\n' +
            '                                    Засоби гігієни',
            subTitle3: 'Послуги',
            subDescription3: 'Заселення в 14:00, Виселення в 11:00,\n' +
            '                                    Конс\'єрж-сервіс, Пральня/хімчистка, Ресторан\n' +
            '                                    європейської, японської та української кухні\n' +
            '                                    Food Hub, Лобі-бар 24/7, Цілодобовий Room\n' +
            '                                    Servise, Конференц-сервіс, Торгово-розважальний\n' +
            '                                    центр',
        },
        roomFamily: {
            title: 'Сімейний Люкс',
            textTop: '  Трикімнатний номер, виконаний в європейському стилі, з\n' +
              '                        двома окремими спальнями. Із вікон відкривається панорамний вид на море\n' +
              '                        та місто. Розташування номерів на 13 поверсі. Номер обладнаний сучасною\n' +
              '                        технікою, меблями, великим двоспальним ліжком в кожній спальні,\n' +
              '                        а також великим розкладним диваном в вітальні. В номері є\n' +
              '                        два окремих санвузли: один з душовою кабіною, другий — з ванною.',
            priceTitle: 'Ціна',
            priceDescription: 'грн',
            areaTitle: 'Площа',
            areaDescription: 'м2',
            guests: 'Гостей',
            guestDescription: '',
            subTitle1: 'В номері',
            subDescription1: 'Ліжко King Size, Розкладний диван,  Журнальний\n' +
              '                                    столик,  Письмовий стіл,  Кондиціонер,\n' +
              '                                    Телевізор,  Телефон, Сейф Міні-бар, Багажна\n' +
              '                                    тумба,  Вішалки,  Стілець,  Гардеробна шафа,  Велике\n' +
              '                                    дзеркало,  WI-FI',
            subTitle2: 'В ванній кімнаті',
            subDescription2: 'Душ/ванна,  Фен,  Рушники,  Халати,  Капці\n' +
              '                                    Засоби гігієни',
            subTitle3: 'Послуги',
            subDescription3: 'Заселення в 14:00, Виселення в 11:00,\n' +
              '                                    Конс\'єрж-сервіс, Пральня/хімчистка, Ресторан\n' +
              '                                    європейської, японської та української кухні\n' +
              '                                    Food Hub, Лобі-бар 24/7, Цілодобовий Room\n' +
              '                                    Servise, Конференц-сервіс, Торгово-розважальний\n' +
              '                                    центр',
        },
        longStayModal: {
            p1: 'Готель Gagarinn пропонує затишні та комфортабельні умови для тривалого проживання, де ви можете відчути справжній домашній затишок під час вашої поїздки.',
            p2: 'Одна з наших особливих пропозицій для вас — знижка на проживання в розмірі 15%*, якщо ви бронюєте номер на термін протягом 5 ночей або більше. Таким чином, ви можете заощадити ще більше на вашому відпочинку у нас.\n' +
                'Будь ласка, зверніть увагу, що мінімальний термін проживання за цим тарифом становить 5 днів.',
            p3: 'У вартість вашого номера також включено Wi-Fi, щоб ви могли залишатися на зв\'язку і насолоджуватися високошвидкісним інтернетом у будь-який час.',
            // p4: 'Ми пропонуємо розміщення дітей до 6 років безкоштовно в одному номері з батьками, без надання додаткового спального місця. А для найменших  — дітей до 3 років, ми раді запропонувати дитяче ліжечко у всіх категоріях номерів без додаткової оплати.',
            // p5: 'Ми пропонуємо безоплатне розміщення для найменших — дітей до 16 років,  при бронюванні родиною номерів категорії Студія або Люкс та раді запропонувати дитяче ліжечко у всіх категоріях номерів без додаткової оплати.',
            p6: 'І щоб зробити ваше перебування ще більш приємним, ми даруємо гостям з дітьми купон на одне безкоштовне відвідування нашого дитячого парку Gagarinn Kids, щоб Ваші діти змогли насолодитися захопливими розвагами!',
            p7: 'Для вашої зручності, в наших номерах категорії "Люкс" і "Студія" доступні два додаткових місця у вигляді розкладного дивана. Додаткове місце коштує 500,00 грн. для дітей від 7 до 11 років та 750 грн. для дітей від 12 років та дорослих на добу за особу, не включаючи сніданок.',
            p8: 'Також хочемо порадувати вас спеціальними цінами на сніданки в форматі шведського столу:',
            p9: 'Діти до 3-х років: безоплатні сніданки',
            p10: 'Діти з 3-х до 12-ти років: 300 грн',
            p11: 'З 12-ти років та для дорослих: 400 грн',
            p12: 'Ми прагнемо зробити ваше тривале проживання в Gagarinn Hotel максимально комфортним і приємним. Надаючи особливі умови, ми сподіваємося, що ви відчуєте себе як вдома!',
            p13: '*Туристичний збір у розмірі 40,00 грн. з особи на день не входить до вартості проживання і має бути сплачений додатково.'
        },
        kidsModal: {
            p1: 'Ми раді оголосити про запровадження нової вигідної акції для сімей з дітьми. Відтепер, при бронюванні номерів категорії Студія або Люкс, всі діти до 16 років зможуть насолодитися відпочинком у нашому готелі абсолютно безоплатно!*',
            p2: 'Основною метою Gagarinn Hotel є забезпечення комфорту та задоволення всіх гостей, особливо молодших членів родини. Безоплатне проживання для дітей —  це чудова можливість витратити більше на розваги та враження під час Вашого сімейного відпочинку!**',
            p3: 'Також хочемо порадувати вас спеціальними цінами на сніданки в форматі шведського столу:',
            p4: 'Діти до 3-х років: безоплатні сніданки',
            p5: 'Діти з 3-х до 12-ти років: 300 грн',
            p6: 'З 12-ти років та для дорослих: 400 грн',
            p7: 'Не пропустіть можливість відвідати Gagarinn Hotel та отримати незабутні враження від сімейного відпочинку в Одесі! Зробіть бронювання номеру вже сьогодні та створюйте моменти, які запам\'ятовуються назавжди. Почніть планувати Вашу подорож прямо зараз!',
            p8: '*Незалежно від кількості дітей в родині.',
            p9: '**Пропозиція сумується з акцією “Long Stay” — знижкою 15% на проживання в готелі від 3 ночей.'
        },
        buttons: {
            btn1: 'Забронювати',
            more: 'Детальніше про номер',
            hide: 'Сховати'
        }
    }
};

/**
 * I18N Localization
 *
 * @type {VueI18n}
 */

// import Page from './App';
import Layout from './components/Layout.vue'
import Layout404 from './components/Layout404.vue'

const routes = [
    {
        path: '/',
        name: 'home',
        component: Layout
    },
    {
        path: '/:section',
        name: 'section',
        component: Layout,
        beforeEnter: (to, from, next) => {
          const sections = ['rooms','food-hub', 'long-stay', 'service','contact', 'faq', 'kids'];
          if(sections.includes(to.params.section)){
            next();
          }
          else{
            next({ name: 'page404' });
          }
        }
    },
    {
        path: '*',
        name: 'page404',
        component: Layout404,
        beforeEnter: (to, from, next) => {
            var meta = document.createElement('meta');
            meta.setAttribute('name', 'robots');
            meta.setAttribute('content', 'noindex');
            document.getElementsByTagName('head')[0].appendChild(meta);
            next();
        }
    },
];

const router = new Router({
    mode: 'history',
    routes: routes // short for `routes: routes`
});

Vue.use(VueI18n);
let lang = localStorage.getItem('language') ? localStorage.getItem('language') : navigator.language.substring(0,2);
// lang = ['ru','uk'].includes(lang) ? 'ru' : 'en';
const i18n = new VueI18n({
    locale: lang,
    messages, // set locale messages
});

//set all meta tags
function setMetaTags(lang){
  document.documentElement.setAttribute('lang', lang);
  let metaContent = {
    // en : {
    //   title: 'Gagarinn Hotel in Odesa - the hotel near Black sea in Arcadia district',
    //   description: 'Gagarinn Hotel is the best place for business and leisure that is located not far from the beaches, nightclubs, up-to-date restaurants and other city attractions'
    // },
    en : {
      title: 'Отель Гагаринн в Одессе - гостиница у моря в районе Аркадия | gagarinn hotel',
      description: 'Бизнес отель «Gagarinn» расположен в самом сердце морской Одессы в курортной зоне Аркадии. Гостиница «Гагаринн» ждет Вас в любое время суток. Hotel «Gagarinn» - it is your choice.'
    },
    ru : {
      title: 'Отель Гагаринн в Одессе - гостиница у моря в районе Аркадия | gagarinn hotel',
      description: 'Бизнес отель «Gagarinn» расположен в самом сердце морской Одессы в курортной зоне Аркадии. Гостиница «Гагаринн» ждет Вас в любое время суток. Hotel «Gagarinn» - it is your choice.'
    },
    uk : {
      title: 'Готель Гагарінн в Одесі - готель біля моря в районі Аркадії | gagarinn hotel',
      description: 'Бізнес-готель «Gagarinn» розташований в самому серці морскої Одеси в курортній зоні Аркадії. Готель «Гагарінн» чекає на Вас в будь-який час доби. Hotel «Gagarinn» - it is your choice.'
    }
  }

  document.title = metaContent[lang].title;

  let metas = document.getElementsByTagName('meta');
  for (let i = 0; i < metas.length; i++) {
    if (metas[i].getAttribute('name') === 'description') {
      metas[i].setAttribute('content', metaContent[lang].description);
    }
  }

  //change link rel alternate
  let altLink = document.querySelector('link[rel="alternate"]');
  if(altLink !== null){
    if(lang === 'en'){
      altLink.setAttribute('hreflang', 'en');
    } else if(lang === 'uk'){
      altLink.setAttribute('hreflang', 'uk');
    } else {
      altLink.setAttribute('hreflang', 'ru-ua');
    }
  }
}
//set html lang attribute
router.beforeEach((to, from, next) => {
  let lang = localStorage.getItem('language') ? localStorage.getItem('language') : navigator.language.substring(0,2);
//   lang = ['ru','uk'].includes(lang) ? 'ru' : 'en';
  setMetaTags(lang);
  next();
});

/**
 * Initialization
 */
new Vue({
    i18n,
    store,
    router,
    data() {
        let lang = localStorage.getItem('language') ? localStorage.getItem('language') : navigator.language.substring(0,2);
        return {
            locale: lang,
            // currentRoute: window.location.pathname
        }
    },
    methods: {
        /**
         * Set Application Locale
         *
         * @param lang : string
         */
        setLocale(lang) {
            i18n.locale = this.locale = lang;
            setMetaTags(lang);
        }
    },
    // computed: {
    //     ViewComponent () {
    //         return routes[this.currentRoute] || NotFound
    //     }
    // },
    render: h => h(App)
    //   render (h) { return h(this.ViewComponent) }
}).$mount('#app');
